module.exports = __webpack_public_path__ + "static/media/07_plantilla_combo_cuadrada_fondo_3.147a6864.jpg";